import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'

require.context('../images', true)

import '../css/application.sass'

import '../javascripts/public/navbar-visibility'
import '../javascripts/public/yandex-metrics'
